module.exports = __webpack_public_path__ + "static/media/robo1.39a04d2f.png";